var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "listWrapper",
      staticClass: "list-wrapper",
      style: _vm.appearanceOverrides,
    },
    [
      _c(
        "div",
        { ref: "list", staticClass: "list" },
        [
          _vm._l(_vm.items, function (item) {
            return [
              _vm.isDivider(item)
                ? _vm._t("divider", null, { divider: item })
                : _vm._t("item", null, { item: item }),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { ref: "moreButtonWrapper", staticClass: "more-button-wrapper" },
        [
          _vm.isMoreButtonVisible
            ? _vm._t("more", null, { overflowItems: _vm.overflowItems })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }